<template>
  <v-card outlined class="mb-4">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>
          {{ equipament.product.product_type }}
          {{ equipament.product.brand }}
          {{ equipament.product.model }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="equipament.ean">
          {{ equipament.ean }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="!readonly">
        <div>
          <v-btn @click="handleClickRemoveEquipament()" icon>
            <v-icon color="red darken-4">mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>

    <v-chip-group class="mx-4">
      <v-chip v-if="equipament.equipamentLocation === 'insured'">
        <v-icon left color="red darken-4">mdi-map-marker</v-icon> Segurado
      </v-chip>
      <v-chip v-else>
        <v-icon left color="blue darken-4">mdi-map-marker-account</v-icon>
        Reparador
      </v-chip>
      <v-chip
        v-if="equipament.invoice"
        :href="getPublicUrl(equipament.invoice.path)"
        target="_blank"
      >
        <v-icon color="green darken-3" left>mdi-cash</v-icon>
        Fatura
      </v-chip>
    </v-chip-group>

    <v-card-text>
      <v-row>
        <v-col
          v-for="path in equipament.product.paths"
          :key="path"
          cols="12"
          sm="4"
          md="3"
          lg="2"
        >
          <v-img :src="getPublicUrl(path)" height="100"></v-img>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="subtitle-1 ma-2">
      <b class="mr-2">Valor reclamado: </b>
      {{
        equipament.invoice ? money.euro(equipament.invoice.total_amount) : "---"
      }}
    </v-card-actions>
  </v-card>
</template>

<script>
import money from "@/tools/money";

export default {
  mixins: [],

  components: {},

  props: {
    equipament: Object,
    readonly: Boolean,
  },

  data() {
    return {
      money,
    };
  },

  methods: {
    handleClickRemoveEquipament() {
      this.$emit("click:remove");
    },
    getPublicUrl(fileSrc) {
      return fileSrc;
    },
  },

  computed: {},
};
</script>
